import showLoader from "../helpers/showLoader";
import ClassicExtension from "./ClassicExtension";
import {Naja} from "naja";

export default class ShowLoaderExtension extends ClassicExtension {

    private targetsWithLoader: Set<Element> = new Set();

    public initialize(naja: Naja): void {
        super.initialize(naja);

        // Clear tracked targets when any AJAX request completes, so spinners
        // can be shown again on subsequent clicks (even if the element was not
        // replaced by a snippet redraw).
        naja.addEventListener('complete', () => {
            this.targetsWithLoader.clear();
        });
    }

    private pruneTargets(): void {
        this.targetsWithLoader.forEach(target => {
            if (!document.contains(target)) {
                this.targetsWithLoader.delete(target);
            }
        });
    }

    protected init($root): void {
        // Show spinner directly on the clicked element (the one with data-show-loader)
        $root.find('[data-show-loader]:not([data-loader-target])').on('click change', (e: Event) => {
            this.showLoaderUntilRedraw(e.currentTarget);
        });

        // Show spinner on the target element specified in data-loader-target
        $root.find('[data-show-loader][data-loader-target]').on('click change', (e: Event) => {
            const selector = $(e.currentTarget).data('loader-target');
            if (!selector) {
                return;
            }
            const target = $(selector)[0];
            if (!target) {
                console.warn(`ShowLoaderExtension: Target element not found for selector "${selector}".`);
                return;
            }
            this.showLoaderUntilRedraw(target);
        });

    }

    private showLoaderUntilRedraw(target: Element): void {
        this.pruneTargets();

        if (this.targetsWithLoader.has(target)) {
            return;
        }

        showLoader($(target));
        this.targetsWithLoader.add(target);
    }
}
